import React, { useEffect, useState } from 'react';
import ModalForm from '../Reusable/ModalForm';
import { useDispatch, useSelector } from 'react-redux';
import { findUserById, findUserWithSignatureById } from '../../actions/user';
import { findAllUserRole } from '../../actions/userRole';
import { ModalForAddOrUpdateUser, Placeholders } from '../../enums/UserEnums';
import { SubmitButton } from '../../enums/GlobalEnums';
import CaseLogo from '../Reusable/Upload-Latest/CaseLogo';

const ModalForUpdateUser = ({ handleClose, handleEdit, show, userId }) => {
  const dispatch = useDispatch();

  const { error, user } = useSelector((state) => state.user);
  const { userRoleList } = useSelector((state) => state.userRole);
  const { loggedUser } = useSelector((state) => state.security);

  const [initialValues, setInitialValues] = useState({
    id: '',
    firstName: '',
    lastName: '',
    username: '',
    address: '',
    phoneNumber: '',
    email: '',
    roleId: '',
    image: null,
  });

  useEffect(() => {
    //dispatch(findUserById(userId || loggedUser.id));
    dispatch(findUserWithSignatureById(userId || loggedUser.id));
    dispatch(findAllUserRole());
  }, [dispatch, userId, loggedUser.id]);

  useEffect(() => {
    if (show && user) {
      console.log(user);
      setInitialValues({
        id: user.id || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        username: user.username || '',
        address: user.address || '',
        phoneNumber: user.phoneNumber || '',
        email: user.email || '',
        roleId: user.roleId || '',
        image: user.signatureUrl
          ? {
              preview: user.signatureUrl,
              name: 'signature.png',
            }
          : null,
      });
    }
  }, [user, show]);

  console.log(initialValues);

  const processImage = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          // Sample corners to detect actual background color
          const bgSamples = [
            [data[0], data[1], data[2]], // top-left
            [(canvas.width - 1) * 4, (canvas.width - 1) * 4 + 1, (canvas.width - 1) * 4 + 2].map((i) => data[i]),
          ];
          const bgR = bgSamples.reduce((s, c) => s + c[0], 0) / bgSamples.length;
          const bgG = bgSamples.reduce((s, c) => s + c[1], 0) / bgSamples.length;
          const bgB = bgSamples.reduce((s, c) => s + c[2], 0) / bgSamples.length;

          const tolerance = 60;

          for (let i = 0; i < data.length; i += 4) {
            const r = data[i], g = data[i + 1], b = data[i + 2];
            const dist = Math.sqrt((r - bgR) ** 2 + (g - bgG) ** 2 + (b - bgB) ** 2);

            if (dist < tolerance) {
              // Background pixel — make transparent
              data[i + 3] = 0;
            } else if (dist < tolerance * 1.5) {
              // Edge pixel — feather for smooth anti-aliasing
              const factor = (dist - tolerance) / (tolerance * 0.5);
              data[i + 3] = Math.round(255 * factor);
            }
            // else: keep the ink pixels fully opaque
          }

          ctx.putImageData(imageData, 0, 0);
          canvas.toBlob((blob) => resolve(blob), 'image/png');
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const fields = [
    {
      name: 'firstName',
      label: Placeholders.firstname,
      type: 'text',
    },
    {
      name: 'lastName',
      label: Placeholders.lastname,
      type: 'text',
    },
    {
      name: 'address',
      label: Placeholders.address,
      type: 'text',
    },
    {
      name: 'phoneNumber',
      label: Placeholders.phone,
      type: 'text',
    },
    {
      name: 'email',
      label: Placeholders.email,
      type: 'text',
    },
    {
      name: 'username',
      label: Placeholders.username,
      type: 'text',
    },
    {
      name: 'roleId',
      label: Placeholders.role,
      type: 'select',
      options: userRoleList.map((role) => ({
        label: role.roleName,
        value: role.id,
      })),
    },
    {
      name: 'image',
      render: ({ value, onChange }) => (
        <CaseLogo
          selectedImage={value}
          onFileChange={(img) => onChange(img)}
          onDeleteImage={() => onChange(null)}
        />
      ),
    },
  ];

  const handleSubmit = async (formData) => {
    const updatedUser = {
      ...user,
      ...formData,
      confirmPassword: user.password,
    };

    const data = new FormData();

    // image ne treba u JSON delu
    delete updatedUser.image;

    data.append(
      'user',
      new Blob([JSON.stringify(updatedUser)], {
        type: 'application/json',
      })
    );

    // upload slike — obradi samo ako je izabrana nova slika
    if (formData.image?.file) {
      const cleanBlob = await processImage(formData.image.file);
      data.append('signatureImage', cleanBlob, 'signature.png');
    }

    handleEdit(data);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateUser.titleForUpdateUser}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.update}
    />
  );
};

export default ModalForUpdateUser;